export default __webpack_public_path__ + "img/icon-phone.8335a046.svg";